// __comment, __reason高さ
function equalizeComments() {
	const items = [...document.querySelectorAll(".member__item")];
	const comments = [...document.querySelectorAll(".member__comment")];
	const reasons = [...document.querySelectorAll(".member__reason")];

	// 一旦リセット
	comments.forEach((el) => (el.style.minHeight = ""));
	reasons.forEach((el) => (el.style.minHeight = ""));

	// 画面幅が769px未満なら何もしない
	if (window.innerWidth < 769) return;

	const cols = 2;

	// ---- コメントの高さを揃える ----
	for (let i = 0; i < items.length; i += cols) {
		const row = comments.slice(i, i + cols);
		const max = Math.max(...row.map((el) => el.getBoundingClientRect().height));
		row.forEach((el) => (el.style.minHeight = `${max}px`));
	}

	// ---- 理由の高さを揃える ----
	for (let i = 0; i < items.length; i += cols) {
		const row = reasons.slice(i, i + cols);
		const max = Math.max(...row.map((el) => el.getBoundingClientRect().height));
		row.forEach((el) => (el.style.minHeight = `${max}px`));
	}
}

window.addEventListener("load", equalizeComments);
window.addEventListener("resize", () => {
	requestAnimationFrame(equalizeComments);
});
